import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { DealService } from "../../services";
import { Accessory, ConfigAccessory, convertToAccessory } from "../../models";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";

@Component({
  selector: "app-accessory-item",
  templateUrl: "./accessory-item.component.html",
  styleUrls: ["./accessory-item.component.scss"]
})
export class AccessoryItemComponent implements OnInit {
  @Input() accessory: ConfigAccessory;
  @Input() _selectedDealAccessory: Accessory;
  @Input() itemIndex: number;
  @Input() inCart = false;
  @Input() iconMode = false;
  @ViewChild("imageArea", {static: true}) imageArea: ElementRef;
  productOptions = []
  defaultSelectionIndex = 0;
  public uiState = {
    isValidStockPhoto: true,
    imageHeight: null,
    activeView: "coverage",
    tabs: [
      {title: "What's Covered?", id: "coverage"},
      {title: "Video", id: "video"},
    ]
  };

  xpelForm: UntypedFormGroup = this.formBuilder.group({
    coverage: [this.selectedDealAccessory ? this.selectedDealAccessory.price : ""]
  });

  @Input() set selectedDealAccessory(acc: Accessory) {
    this._selectedDealAccessory = acc;
    if (this.xpelForm) {
      this.xpelForm.patchValue({
        coverage: [this._selectedDealAccessory ? this._selectedDealAccessory.price : ""]
      })
    }
  }

  constructor(private formBuilder: UntypedFormBuilder,
              private dealService: DealService) { }

  ngOnInit() {
    this.productOptions = this.accessory.options.map(option => {
      return {
        label: option.label,
        value: option.price,
      }
    });

    let defaultIndex = this.accessory.options.findIndex(option => option.defaultSelection);

    this.defaultSelectionIndex = defaultIndex !== -1 ? defaultIndex : 0;
  }

  // ACTIONS

  onSelectAccessory(accessory: ConfigAccessory) {
    if (this._selectedDealAccessory) {
      this.dealService.submitAccessory(this._selectedDealAccessory);  
    } else {
      this.dealService.submitAccessory(convertToAccessory(accessory, this.defaultSelectionIndex));
    }
  }

  // UI RENDERING

  invalidateImage() {
    this.uiState.isValidStockPhoto = false;
  }

  get iconUrl(): string {
    return this.uiState.isValidStockPhoto ? this.accessory.accessoryLink.iconUrl : null;
  }

  get imageHeight(): number {
    return this.uiState.imageHeight;
  }

  onXpelCoverageChange($event) {
    let previousValue = this._selectedDealAccessory ? this._selectedDealAccessory.price : null;
    let previousProduct = this.productOptions.find(option => option.value === previousValue);
    let currentProductIndex = this.productOptions.findIndex(option => option.value === Number.parseFloat($event.target.value));
    let currentProduct = this.productOptions[currentProductIndex];

    this._selectedDealAccessory = convertToAccessory(this.accessory, currentProductIndex);
    this.dealService.dispatchAddEvent({
      shortName: 'Paint Protection Film Package Changed',
      oldValue: previousProduct ? previousProduct.label : null,
      newValue: currentProduct.label
    })
    this.dealService.submitAccessory(this._selectedDealAccessory);
    this.dealService.dispatchCalcTax();
  }

  getIconSrc(link: string): string {
    return link.slice(0, -4) + "-v2." + link.slice(-3);
  }
}
